import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { fetchUserRole } from 'actions/authentication';
import { queryAuthorizedVenues } from 'actions/venue';
import SelectableTable from 'components/Utility/Tables/SelectableTable';
import PropTypes from 'prop-types';
import React from 'react';
import { Loader } from 'react-overlay-loader';
import { connect } from 'react-redux';
import PillSelectBox from '../../../../components/Dashboard/Panels/MenuEditor/components/shared/PillSelectBox';

class VenueSwitcher extends React.Component {
  state = {
    selectedVenue: {},
    selectedVenueId: 'none-selected',
  };
  handleVenueSelect(venue) {
    this.props.fetchUserRole();
    this.setState({ selectedVenue: venue });
  }
  componentDidMount() {
    this.props.queryAuthorizedVenues('');
  }

  onSearchChanged(event) {
    const searchTerm = event.target.value;
    this.props.queryAuthorizedVenues(searchTerm);
  }

  focusUsernameInput = input => {
    if (input) {
      setTimeout(() => {
        input.focus();
      }, 100);
    }
  };

  render() {
    const venues = this.props.venueSwitcherSearchResults;

    return (
      <Dialog
        disableBackdropClick={this.props.locked}
        disableEscapeKeyDown={this.props.locked}
        fullScreen={this.props.fullScreen}
        open={this.props.open}
        onClose={this.props.onClose}
        aria-labelledby="venue-switcher"
      >
        <DialogTitle id="responsive-dialog-title">Switch Venue</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You can use this tool to switch venues. Choose a venue you wish to
            manage from the list and then press "Select".
          </DialogContentText>

          {this.props.role === 'admin' ? (
            <React.Fragment>
              <TextField
                onChange={e => this.onSearchChanged(e)}
                style={{ marginTop: '20px' }}
                label="Venue Name"
                fullWidth
                inputRef={this.focusUsernameInput}
              />
              <Paper>
                <Loader loading={this.props.fetchingAuthorizedVenues} />
                <SelectableTable
                  onItemSelect={v => this.handleVenueSelect(v)}
                  dataSource={this.props.venueSwitcherSearchResults}
                  selectionKey="_id"
                />
              </Paper>
            </React.Fragment>
          ) : (
            <PillSelectBox
              data-testid="select-venue-dropdown"
              value={this.state.selectedVenueId}
              onChange={e => {
                const selectedVenueId = e.target.value;
                const selectedVenue = venues.find(
                  v => v._id === selectedVenueId
                );
                this.setState({ selectedVenue, selectedVenueId });
              }}
            >
              <option key="default" value="none-selected">
                Select a venue
              </option>
              {venues.map(venue => {
                return (
                  <option key={venue._id} value={venue._id}>
                    {venue.name}
                  </option>
                );
              })}
            </PillSelectBox>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            disabled={this.props.locked}
            onClick={this.props.onClose}
            color="primary"
          >
            Close
          </Button>
          <Button
            disabled={!this.state.selectedVenue}
            onClick={() => this.props.onVenueSelect(this.state.selectedVenue)}
            color="primary"
            autoFocus
          >
            Select{' '}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

VenueSwitcher.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  locked: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
  const { fetchingAuthorizedVenues, venueSwitcherSearchResults } = state.venue;
  const role = state.authentication.role;
  return { fetchingAuthorizedVenues, venueSwitcherSearchResults, role };
};

const mapDispatchToProps = dispatch => ({
  queryAuthorizedVenues: query => dispatch(queryAuthorizedVenues(query)),
  fetchUserRole: () => dispatch(fetchUserRole()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(VenueSwitcher));



// WEBPACK FOOTER //
// ./src/components/Dashboard/MegaNav/VenueSwitcher/index.jsx